// applications
import { http, HttpResponse } from 'msw';
import { AccountApiPaths } from '../../../slices/account-api.slice';
import { apiUrl } from '../apiUrl';
import { generateMockApplications, boaApplication, fedexApplication } from '../../data/application';

const applicationsQuery = http.get(apiUrl(AccountApiPaths.userApplications), () => {
    return HttpResponse.json({ tiles: [boaApplication, fedexApplication, ...generateMockApplications()] });
});

export const applicationHandlers = [applicationsQuery];
